import { Injectable, inject } from "@angular/core";

import { AggregateHelperService, IAggregateActionHandler } from "@tylertech/aggregates-module";
import { GeneralLedgerDialogService } from "@tylertech/general-ledger-module";
import { IAggregate, ICardData, ICardAction, RequisitionItemViewModel } from "@tylertech/tyler-api-types";

import { RequisitionService } from "../services";

@Injectable()
export class RequisitionApprovalActionHandler implements IAggregateActionHandler
{
    private readonly $aggregateHelperService = inject(AggregateHelperService);
    private readonly $requisitionService = inject(RequisitionService);
    private readonly generalLedgerDialogService = inject(GeneralLedgerDialogService);


    predicate(aggregate: IAggregate, _cardData: ICardData, action: ICardAction): boolean
    {
        return aggregate.AggregateProviderId === "Finance.RequisitionApproval" && action.Id === "BudgetRecap";
    }

    execute(_aggregate: IAggregate, cardData: ICardData, _action: ICardAction): Promise<boolean>
    {
        const id = this.$aggregateHelperService.getFieldValue(cardData, "RequisitionId");
        return this.$requisitionService.GetItems(id)
            .then((items: Array<RequisitionItemViewModel>) =>
            {
                const issued = new Date(this.$aggregateHelperService.getFieldValue(cardData, "Issue Date"));
                return this.generalLedgerDialogService.showAccountBudgetRecap(items, issued);
            });
    }

    load(_aggregate: IAggregate, _cardData: ICardData, _action: ICardAction): void
    {
        /* NO_OP */
    }
}
